export default "__VITE_ASSET__d6c5b9cc__"